import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import AOS from "aos";

function developmentsSlider() {
  const isPresent = document.querySelector(".developments-slider");
  if (!isPresent) {
    return;
  }

  function toggleNavVisibility(swiper) {
    const slidesPerView = swiper.params.slidesPerView;
    const totalSlides = swiper.slides.length;
    const allVisible = totalSlides <= slidesPerView;
    swiper.el.classList.toggle("swiper-lock", allVisible);
  }

  new Swiper(".developments-slider", {
    modules: [Navigation, Autoplay, Pagination],
    loop: false,
    autoplay: { delay: 8000 },
    keyboard: { enabled: true },
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      1250: { slidesPerView: 4 },
      768: { slidesPerView: 3 },
      640: { slidesPerView: 2 },
    },
    speed: 800,
    setWrapperSize: true,
    pagination: {
      el: ".developments-slider-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".developments-slider-next",
      prevEl: ".developments-slider-prev",
    },
    on: {
      init: toggleNavVisibility,
      resize: toggleNavVisibility,
    },
  });

  AOS.refresh();
}

export { developmentsSlider };
